import { IonIcon } from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { WP_HouseMainPage } from '../../model/models';
import { AppContext } from '../../state/AppContextProvider';
import DirectoryWidgetTab from '../directory/DirectoryWidget';
import Faq from '../faq/Faq';
import { SanitizeHTML } from '../globals/SanitizeHTML';

interface AboutTabProps {
  houseMainPage: WP_HouseMainPage;
}

export const AboutTab: React.FC<AboutTabProps> = ({ houseMainPage }) => {
  const { state } = useContext(AppContext);
  const houseId = state.house?.term_id || -1;

  const contacts =
    houseMainPage && houseMainPage.acf && houseMainPage.acf.contact
      ? houseMainPage.acf.contact
      : [];

  const locations =
    houseMainPage &&
    houseMainPage.acf &&
    typeof houseMainPage.acf.locations == 'object'
      ? houseMainPage.acf.locations
      : [];

  return (
    <div className="w-full text-left mt-2 px-2 md:mt-5">
      <Link
        className="hidden text-sm items-center font-bold text-primary mb-8 md:flex"
        to="/house"
      >
        <IonIcon className="text-primary mr-2" icon={chevronBackOutline} />
        <FormattedMessage id="Go back" />
      </Link>
      {locations.length === 1
        ? locations.map((location, index) => {
            if (location.url !== '' || location.place !== false) {
              return location.place !== false ? (
                <Link
                  key={index}
                  className="mb-6 block hover:opacity-75"
                  to={'/pages/map/' + location.place}
                >
                  <div className="flex self-end items-center px-6 py-4 mt-3 w-full border border-transparent shadow-sm text-sm font-bold rounded-3xl text-white bg-primary bg-house-localization-pattern hover:bg-primary focus:outline-none ">
                    <IonIcon
                      className="bg-white stroke-current text-primary p-2 rounded-full mr-5 w-7 h-7"
                      src="/assets/nav/compass.svg"
                    />
                    <div>
                      <h4 className="text-white text-sm font-bold">
                        {location.name}
                      </h4>
                    </div>
                  </div>
                </Link>
              ) : (
                <a
                  key={index}
                  className="mb-6 block hover:opacity-75"
                  target="_blank"
                  rel="noreferrer"
                  href={location.url}
                >
                  <div className="flex self-end items-center px-6 py-4 mt-3 w-full border border-transparent shadow-sm text-sm font-bold rounded-3xl text-white bg-primary bg-house-localization-pattern hover:bg-primary focus:outline-none ">
                    <IonIcon
                      className="bg-white stroke-current text-primary p-2 rounded-full mr-5 w-7 h-7"
                      src="/assets/nav/compass.svg"
                    />
                    <div>
                      <h4 className="text-white text-sm font-bold">
                        {location.name}
                      </h4>
                    </div>
                  </div>
                </a>
              );
            }
            return true;
          })
        : ''}
      {locations.length > 1 ? (
        <div
          style={{ backgroundImage: 'url("/assets/img/bg-house.png")' }}
          className="inline-flex items-center px-6 py-4 mb-6 w-full border border-transparent bg-cover shadow-sm text-sm font-bold rounded-2xl text-white bg-primary hover:bg-secondary focus:outline-none "
        >
          <IonIcon
            className="bg-white stroke-current text-primary p-2 rounded-full mr-5 w-7 h-7"
            src="/assets/nav/compass.svg"
          />
          <ul className="flex flex-col">
            {locations.map((location, index) => {
              if (location.url !== '' || location.place !== false) {
                return location.place !== false ? (
                  <Link key={index} className="" to={'/pages/map/' + location.place}>
                    {location.name}
                  </Link>
                ) : (
                  <a
                    key={index}
                    target="_blank"
                    rel="noreferrer"
                    href={location.url}
                  >
                    {location.name}
                  </a>
                );
              }
              return true;
            })}
          </ul>
        </div>
      ) : (
        ''
      )}
      <h1 className="border-after font-semibold mb-8 text-xl inline-block">
        <FormattedMessage id="Contact House" />
      </h1>
      <div className="mt-2 font-normal text-sm">
        <SanitizeHTML html={contacts} className="mb-2 leading-4 text-xs" />
      </div>
      {houseMainPage?.acf?.faq && <Faq faq={houseMainPage.acf.faq} />}
      <br />
      <div className="w-full !md:p-8 border-0 bg-white rounded-3xl px-6">
        <DirectoryWidgetTab
          title="My house committee"
          tagSlugs={['committee']}
          house={houseId}
          nbUserToDisplay={3}
        />
      </div>
    </div>
  );
};
export const AboutTabDesktop: React.FC<AboutTabProps> = ({ houseMainPage }) => {
  const contacts =
    houseMainPage && houseMainPage.acf && houseMainPage.acf.contact
      ? houseMainPage.acf.contact
      : [];

  const locations =
    houseMainPage &&
    houseMainPage.acf &&
    typeof houseMainPage.acf.locations == 'object'
      ? houseMainPage.acf.locations
      : [];
  return (
    <div className="w-full text-left mt-2 bg-white bg-opacity-60 p-7 border-0 rounded-3xl">
      <div className="flex flex-row justify-between items-center mb-8 ">
        <h1 className="font-semibold text-xl inline-block m-0">
          <FormattedMessage id="About" />
        </h1>
        <Link
          to="/house/about"
          className="text-primary font-bold text-xs m-0 cursor-pointer"
        >
          <FormattedMessage id="See more" />
        </Link>
      </div>
      {locations.length === 1
        ? locations.map((location, index) => {
            if (location.url !== '' || location.place !== false) {
              return location.place !== false ? (
                <Link
                  key={index}
                  className="mb-6 block hover:opacity-75"
                  to={'/pages/map/' + location.place}
                >
                  <div className="flex self-end items-center px-6 py-4 mt-3 w-full border border-transparent shadow-sm text-sm font-bold rounded-3xl text-white bg-primary bg-house-localization-pattern hover:bg-primary focus:outline-none ">
                    <IonIcon
                      className="bg-white stroke-current text-primary p-2 rounded-full mr-5 w-7 h-7"
                      src="/assets/nav/compass.svg"
                    />
                    <div>
                      <h4 className="text-white text-sm font-bold">
                        {location.name}
                      </h4>
                    </div>
                  </div>
                </Link>
              ) : (
                <a
                  key={index}
                  className="mb-6 block hover:opacity-75"
                  rel="noreferrer"
                  href={location.url}
                >
                  <div className="flex self-end items-center px-6 py-4 mt-3 w-full border border-transparent shadow-sm text-sm font-bold rounded-3xl text-white bg-primary bg-house-localization-pattern hover:bg-primary focus:outline-none ">
                    <IonIcon
                      className="bg-white stroke-current text-primary p-2 rounded-full mr-5 w-7 h-7"
                      src="/assets/nav/compass.svg"
                    />
                    <div>
                      <h4 className="text-white text-sm font-bold">
                        {location.name}
                      </h4>
                    </div>
                  </div>
                </a>
              );
            }
            return true;
          })
        : ''}
      {locations.length > 1 ? (
        <div
          style={{ backgroundImage: 'url("/assets/img/bg-house.png")' }}
          className="inline-flex items-center px-6 py-4 mb-6 w-full border border-transparent bg-cover shadow-sm text-sm font-bold rounded-2xl text-white bg-primary hover:bg-secondary focus:outline-none "
        >
          <IonIcon
            className="bg-white stroke-current text-primary p-2 rounded-full mr-5 w-7 h-7"
            src="/assets/nav/compass.svg"
          />
          <ul className="flex flex-col">
            {locations.map((location, index) => {
              if (location.url !== '' || location.place !== false) {
                return location.place !== false ? (
                  <Link key={index} className="" to={'/pages/map/' + location.place}>
                    {location.name}
                  </Link>
                ) : (
                  <li key={index} className="text-left">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={location.url}
                    >
                      {location.name}
                    </a>
                  </li>
                );
              }
              return true;
            })}
          </ul>
        </div>
      ) : (
        ''
      )}

      <div className="mt-2 font-normal text-sm">
        <SanitizeHTML html={contacts} className="mb-2 leading-4 text-xs" />
      </div>

      {(houseMainPage?.acf?.faq || []).length > 0 && (
        <Link
          to="/house/about"
          className="text-primary font-bold text-xs m-0 cursor-pointer"
        >
          FAQ
        </Link>
      )}

      {}
    </div>
  );
};
